__turbopack_context__.v({
  "card": "BuildIncome-module__zL7D6a__card",
  "cardBtn": "BuildIncome-module__zL7D6a__cardBtn",
  "cardDesc": "BuildIncome-module__zL7D6a__cardDesc",
  "cardIcon": "BuildIncome-module__zL7D6a__cardIcon",
  "cardTitle": "BuildIncome-module__zL7D6a__cardTitle",
  "chapter": "BuildIncome-module__zL7D6a__chapter",
  "chapterNum": "BuildIncome-module__zL7D6a__chapterNum",
  "chapters": "BuildIncome-module__zL7D6a__chapters",
  "eyebrow": "BuildIncome-module__zL7D6a__eyebrow",
  "grid": "BuildIncome-module__zL7D6a__grid",
  "h1": "BuildIncome-module__zL7D6a__h1",
  "header": "BuildIncome-module__zL7D6a__header",
  "hero": "BuildIncome-module__zL7D6a__hero",
  "heroActions": "BuildIncome-module__zL7D6a__heroActions",
  "heroBody": "BuildIncome-module__zL7D6a__heroBody",
  "heroCta": "BuildIncome-module__zL7D6a__heroCta",
  "heroHint": "BuildIncome-module__zL7D6a__heroHint",
  "heroMeta": "BuildIncome-module__zL7D6a__heroMeta",
  "heroMetaItem": "BuildIncome-module__zL7D6a__heroMetaItem",
  "heroTag": "BuildIncome-module__zL7D6a__heroTag",
  "heroTitle": "BuildIncome-module__zL7D6a__heroTitle",
  "joined": "BuildIncome-module__zL7D6a__joined",
  "page": "BuildIncome-module__zL7D6a__page",
  "sub": "BuildIncome-module__zL7D6a__sub",
  "tracks": "BuildIncome-module__zL7D6a__tracks",
  "tracksHead": "BuildIncome-module__zL7D6a__tracksHead",
  "tracksSub": "BuildIncome-module__zL7D6a__tracksSub",
  "tracksTitle": "BuildIncome-module__zL7D6a__tracksTitle",
});
